import Input from '../../Input/Input';
import validator from "validator";
import './PersonalInfo.css';
import { CheckedIcon } from '../../../assets/icons/icons';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { ConfigContext } from '../../../assets/contexts/configContext';
import { DELIVERY_TYPE_VALUES, OWN_DELIVERY_TYPE } from '../../../assets/utils/constants';
import AddressInput from './AddressInput/AddressInput';
import { formatNewAddress } from '../../../assets/utils/utils';
import MapEmbed from './MapEmbed/MapEmbed';

function PersonalInfo({ personal, setPersonal, personalValidity, setPersonalValidity, delivery, setDelivery, total }) {
  const config = useContext(ConfigContext)
  const { initialConstants } = config
  const { CONSTANTS, DELIVERIES } = initialConstants
  const { SHOW_DELIVERY = true } = CONSTANTS

  function handleChange(e) {
    const input = e.target;
    const name = input.name;
    let value = input.value;

    switch (name) {
      case "phone": {
        let inputValue = e.target.value.replace(/\D/g, '')
        let formattedInputValue = '';
        if (!inputValue) {
          setPersonal(prevValue => ({
            ...prevValue,
            [name]: '',
          }))
          setPersonalValidity((prevValue) => ({
            ...prevValue,
            [name]: {
              errorMessage: 'Можно вводить только цифры',
              validState: false
            }
          }))
        }
        else {
          if (['7', '8', '9'].indexOf(inputValue[0]) > -1) {
            setPersonalValidity((prevValue) => ({
              ...prevValue,
              [name]: {
                errorMessage: '',
                validState: false
              }
            }))
            if (inputValue[0] === '9') inputValue = '7' + inputValue;

            let firstSimbols = (inputValue[0] === '8') ? '8' : '+7';
            formattedInputValue = firstSimbols + ' '

            if (inputValue.length > 1) {
              formattedInputValue += '(' + inputValue.substring(1, 4)
            }
            if (inputValue.length >= 5) {
              formattedInputValue += ') ' + inputValue.substring(4, 7)
            }
            if (inputValue.length >= 8) {
              formattedInputValue += '-' + inputValue.substring(7, 9)
            }
            if (inputValue.length >= 10) {
              formattedInputValue += '-' + inputValue.substring(9, 11)
            }
            if (inputValue.length >= 11) {
              setPersonalValidity((prevValue) => ({
                ...prevValue,
                [name]: {
                  errorMessage: '',
                  validState: true
                }
              }));
            } else {
              setPersonalValidity((prevValue) => ({
                ...prevValue,
                [name]: {
                  errorMessage: '',
                  validState: false
                }
              }));
            }
          } else {
            formattedInputValue = '+' + inputValue.substring(0, 16)
            setPersonalValidity((prevValue) => ({
              ...prevValue,
              [name]: {
                errorMessage: 'Только номера РФ',
                validState: false
              }
            }));
          }

          setPersonal(prevValue => ({
            ...prevValue,
            [name]: formattedInputValue,
          }))
        }
        break;
      }

      case "email": {
        if (!value) {
          setPersonalValidity((prevValue) => ({
            ...prevValue,
            [name]: {
              errorMessage: "",
              validState: false,
            },
          }));
        }
        if (value.length >= 2) {
          if (validator.isEmail(value)) {
            setPersonalValidity((prevValue) => ({
              ...prevValue,
              [name]: {
                errorMessage: "",
                validState: true,
              },
            }));
          } else {
            setPersonalValidity((prevValue) => ({
              ...prevValue,
              [name]: {
                errorMessage: !e.target.validity.valid
                  ? e.target.validationMessage
                  : "Invalid email",
                validState: false,
              },
            }));
          }
        }
        setPersonal((prevValue) => ({
          ...prevValue,
          [name]: value,
        }));
        break;
      }

      default:
        setPersonal((prevValue) => ({
          ...prevValue,
          [name]: value,
        }));
        break;
    }
  }

  function handlePhoneDelite(e) {
    if (e.keyCode === 8 && e.target.value.replace(/\D/g, '').length === 1) {
      setPersonal(prevValue => ({
        ...prevValue,
        phone: '',
      }))
    }
    if (e.keyCode === 8 && e.target.value.replace(/\D/g, '').length < 11) {
      setPersonalValidity(prevValue => ({
        ...prevValue,
        phone: {
          errorMessage: '',
          validState: false
        }
      }));
    }
  }

  function handleSelectDeliveryType({ item }) {
    setDelivery(prevValue => ({
      ...prevValue,
      type: item,
      hint_selected: '',
      address: '',
      entrance: '',
      entry_code: '',
      floor: '',
      apartment: '',
      comment: '',
      client_coords: undefined, // сбрасываем карту клиента при смене способа
    }))
    console.log(item)
  }

  function toggleCheckbox() {
    setPersonal(prevValue => ({
      ...prevValue,
      checkbox: !prevValue.checkbox,
    }))
  }

  function handleDeliveryChange(e) {
    const input = e.target;
    const name = input.name;
    let value = input.value;
    setDelivery((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  }

  // coords магазина (для самовывоза или reference)
  const hasStoreCoords =
    delivery?.type?.data &&
    Array.isArray(delivery.type.data.coords) &&
    delivery.type.data.coords.length === 2 &&
    typeof delivery.type.data.coords[0] === "number" &&
    typeof delivery.type.data.coords[1] === "number";

  // coords клиента (когда выбран hint и подтянуты координаты)
  const hasClientCoords =
    Array.isArray(delivery?.client_coords) &&
    delivery.client_coords.length === 2 &&
    typeof delivery.client_coords[0] === "number" &&
    typeof delivery.client_coords[1] === "number";

  const isOwnDelivery = delivery?.type?.delivery_type === OWN_DELIVERY_TYPE;

  return (
    <form className='personal-info' onSubmit={(evt) => { evt.preventDefault() }}>
      <div className='personal-info__inputs-container'>
        <h3 className='personal-info__inputs-title'>Информация о получателе</h3>
        <div className='personal-info__two-inputs'>
          <div className="personal-info__input">
            <Input
              label={"Имя"}
              value={personal.first_name}
              handleChange={handleChange}
              name={"first_name"}
            />
          </div>
          <div className="personal-info__input">
            <Input
              label={"Фамилия"}
              value={personal.last_name}
              handleChange={handleChange}
              name={"last_name"}
            />
          </div>
        </div>
        <div className='personal-info__two-inputs'>
          <div className="personal-info__input">
            <Input
              label={"Номер телефона"}
              value={personal.phone}
              handleChange={handleChange}
              name={"phone"}
              inputMode='tel'
              error={personalValidity.phone}
              onKeyDown={handlePhoneDelite}
            />
          </div>
          <div className="personal-info__input">
            <Input
              label={"Эл. почта"}
              value={personal.email}
              handleChange={handleChange}
              name={"email"}
              inputMode='email'
            />
          </div>
        </div>
      </div>

      {DELIVERIES && DELIVERIES.length > 1 ? (
        <div className='personal-info__inputs-container'>
          <h3 className='personal-info__inputs-title'>Способ получения</h3>
          <div
            className='personal-info__select-input-box'
            style={{ gridTemplateColumns: `repeat(${DELIVERIES.length}, minMax(0, 1fr))` }}
          >
            {DELIVERIES.map((item, i) => (
              <button
                className={`personal-info__select-input ${delivery?.type?.delivery_type === item.delivery_type ? 'personal-info__select-input_selected' : ''}`}
                key={`personal-info__select-input_delivery-type_${i}`}
                type='button'
                onClick={() => { handleSelectDeliveryType({ item }) }}
              >
                {DELIVERY_TYPE_VALUES[item.delivery_type]}
              </button>
            ))}
          </div>
        </div>
      ) : null}

      <div className='personal-info__inputs-container'>
        {isOwnDelivery ? (
          <>
            {DELIVERIES && DELIVERIES.length === 1 ? (
              <h3 className='personal-info__inputs-title'>Адрес доставки</h3>
            ) : null}

            <div className="personal-info__address-input">
              <AddressInput
                form={delivery}
                setForm={setDelivery}
                error={total.NOT_DELIVERABLE}
                hint={total.DELIVERY_TIME}
              />
            </div>

            <div className='personal-info__two-inputs'>
              <div className="personal-info__input">
                <Input
                  label={"Квартира"}
                  value={delivery.apartment}
                  handleChange={handleDeliveryChange}
                  name={"apartment"}
                />
              </div>
              <div className="personal-info__input">
                <Input
                  label={"Домофон"}
                  value={delivery.entry_code}
                  handleChange={handleDeliveryChange}
                  name={"entry_code"}
                />
              </div>
            </div>

            <div className='personal-info__two-inputs'>
              <div className="personal-info__input">
                <Input
                  label={"Подъезд"}
                  value={delivery.entrance}
                  handleChange={handleDeliveryChange}
                  name={"entrance"}
                />
              </div>
              <div className="personal-info__input">
                <Input
                  label={"Этаж"}
                  value={delivery.floor}
                  handleChange={handleDeliveryChange}
                  name={"floor"}
                />
              </div>
            </div>

            <div className="personal-info__input">
              <Input
                label={"Комментарий для курьера"}
                value={delivery.comment}
                handleChange={handleDeliveryChange}
                name={"comment"}
              />
            </div>

            {/* Карта адреса клиента (если выбран hint и подтянулись координаты) */}
            {SHOW_DELIVERY && hasClientCoords ? (
              <div style={{ marginTop: 16 }}>
                <MapEmbed
                  coords={delivery.client_coords} // [lon, lat]
                  title={`Адрес доставки на карте`}
                  height={240}
                />
              </div>
            ) : null}


          </>
        ) : (
          // Самовывоз
          SHOW_DELIVERY && delivery?.type?.data ? (
            <>
              <p className='personal-info__no-delivery-title'>
                Самовывоз по адресу: <b>{formatNewAddress(delivery.type.data)}</b>
              </p>
              {hasStoreCoords ? (
                <MapEmbed
                  coords={delivery.type.data.coords}
                  title={null}
                  height={240}
                />
              ) : null}
            </>
          ) : null
        )}

        <button
          className={`personal-info__checkbox ${personal.checkbox ? 'personal-info__checkbox_selected' : ''}`}
          onClick={toggleCheckbox}
          type='button'
        >
          <div className='personal-info__checkbox-box'>
            <CheckedIcon
              mainClassName={'personal-info__checkbox-box-icon'}
              strokeClassName={'personal-info__checkbox-box-icon-stroke'}
            />
          </div>
          <p className='personal-info__checkbox-text'>
            Оформляя заказ вы соглашаетесь с условиями <Link target='_blank' to={'/docs/privacy-policy'} className='personal-info__checkbox-text-link'>оферты</Link> и даете <Link target='_blank' to={'/docs/user-agreement'} className='personal-info__checkbox-text-link'>согласие на обработку персональных данных</Link>
          </p>
        </button>
      </div>
    </form>
  );
}

export default PersonalInfo;
